import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Btn from '../button/btn';
import './app-update-prompt.css';

function AppUpdatePrompt({ visible, title, changes, onUpdate, onDismiss }) {
  if (!visible) {
    return null;
  }

  return (
    <div className="app-update-prompt" role="dialog" aria-live="polite" aria-label="بروزرسانی اپ">
      <div className="app-update-prompt__body">
        <p className="app-update-prompt__title">{title}</p>
        {changes && changes.length > 0 && (
          <ul className="app-update-prompt__list">
            {changes.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </div>
      <div className="app-update-prompt__actions">
        <Btn type="button" className="btn-main btn-sm" onClick={onUpdate}>
          بروزرسانی
        </Btn>
        <Btn type="button" className="btn-outline btn-sm" onClick={onDismiss}>
          بعداً
        </Btn>
      </div>
    </div>
  );
}

AppUpdatePrompt.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  changes: PropTypes.arrayOf(PropTypes.string),
  onUpdate: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

AppUpdatePrompt.defaultProps = {
  visible: false,
  title: '',
  changes: [],
};

export default memo(AppUpdatePrompt);
